import {Page} from './Page';
import {Main} from './pages/Main';
import {Projects} from "./pages/Projects/Projects";
import {About} from "./pages/About";
import {Blog} from "./pages/Blog/Blog";
import {Resume} from "./pages/Resume";
import {Reel} from "./pages/Reel";
import {Project} from './pages/Projects/Project';
import {Post} from "./pages/Blog/Post";
import {Podcast} from "./pages/Podcast";
import {PodcastFeed} from "./pages/PodcastFeed";
import PodcastList from "./pages/PodcastList";

Page.Main = Main;
Page.About = About;
Page.Projects = Projects;
Page.Project = Project;
Page.Blog = Blog;
Page.Post = Post;
Page.Resume = Resume;
Page.Reel = Reel;
Page.PodcastList = PodcastList;
Page.Podcast = Podcast;
Page.PodcastFeed = PodcastFeed;

export default Page;



// WEBPACK FOOTER //
// ./src/page/index.js